export default "/wstETH.8e34f1e2e5ac7a745bca710386f18fad.svg";